import { MoveGenerator } from '../../jscaip/AI/AI';
import { PenteMove } from './PenteMove';
export class PenteMoveGenerator extends MoveGenerator {
    getListMoves(node, _config) {
        const state = node.gameState;
        const moves = [];
        state.forEachCoord((coord, content) => {
            if (content.isNone()) {
                moves.push(PenteMove.of(coord));
            }
        });
        return moves;
    }
}
